'use strict';

export const SET_PRODUCTS_LIST = 'SET_PRODUCTS_LIST';
export const SET_SELECTED_ITEMS = 'SET_SELECTED_ITEMS';
export const SET_ORDER_INFO = 'SET_ORDER_INFO';
export const SET_CUSTOMER_INFO = 'SET_CUSTOMER_INFO';
export const SET_MOQ_DATA = 'SET_MOQ_DATA';
export const SET_AUTHENTICATION_DETAILS = 'SET_AUTHENTICATION_DETAILS';
export const SET_CUSTOMER_ORDERS_LIST = 'SET_CUSTOMER_ORDERS_LIST';
export const SET_UPDATE_STOCKS_ITEMS = 'SET_UPDATE_STOCKS_ITEMS';
export const SET_DASHBOARD_DATA = 'SET_DASHBOARD_DATA';



// WEBPACK FOOTER //
// ./src/client/actions/events.js